import api from "./api";

export async function getAllSlides() {
    const response = await api.get("/slides");
    return response;
}